/**
 * DownloadApp
 * 
 * @Author: Focci
 * @Date: 2023-07-20 14:22:27
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-20 14:22:27
 */

'use client'

// import PropTypes from 'prop-types'
import Popover from '@mui/material/Popover'
import SVGMobile from '@img/mobile.svg'
import downloadAppImg from '@img/hg-dowload-app-qrcode.png'
import downloadAppImgAu from '@img/hg-dowload-app-qrcode-au.png'
import { useTranslations } from 'next-intl'
import { useState } from 'react'
import { isAU } from '@lib/utils'

export default function DownloadApp() {
  const [anchorEl, setAnchorEl] = useState(null)
  const ts = useTranslations('search')
  const open = Boolean(anchorEl)

  return (
    <>
      <div
        className="hidden lg:flex items-center cursor-pointer"
        onMouseEnter={(e) => setAnchorEl(e.currentTarget)}
      >
        <SVGMobile />
        <span className="ml-1 text-f.6">
          {ts('downloadApp')}
        </span>
      </div>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        {open && <img 
          src={isAU ? downloadAppImgAu.src : downloadAppImg.src}
          alt="Download App"
          width={150} 
          height={150}
          onMouseLeave={() => setAnchorEl(null)} 
        />}
      </Popover>
    </>
  )
}

// DownloadApp.propTypes = {
//   className: PropTypes.string,
// }
